// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2qLLG","topBottomGutter":"Layout_topBottomGutter__3kK0s"};